import { library } from '@fortawesome/fontawesome-svg-core';
import { faSquarePlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslator } from '@Localization';
import { IconButton } from '@mui/joy';
import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { DisabledWhenPolicyExceeded } from '../../../containers/DisabledWhenPolicyExceeded';
import { EnableFor } from '../../../containers/EnableForRole';
import { useWorkspacePermissions } from '../workspaces.permissions';
import { IWorkspacesStore } from '../workspaces.store';

interface IProps {
  onCreateButtonClicked: () => void;
}

library.add(faSquarePlus);

export const CreateWorkspaceButton = observer((props: IProps): ReactElement => {
  const canCreate = useWorkspacePermissions().canCreateWorkspace();
  const workspaceStore = useInjection(IWorkspacesStore.$);
  const { t } = useTranslator();

  return (
    <div className='create-workspace'>
      <DisabledWhenPolicyExceeded
        limitType='workspace'
        isExceeded={!workspaceStore.canAddWorkspace}
      >
        <EnableFor hasPermission={canCreate}>
          <IconButton
            size='lg'
            variant='topbar'
            className='create-workspace-button'
            title={t('create_workspace')}
            onClick={props.onCreateButtonClicked}
          >
            <FontAwesomeIcon icon={faSquarePlus} />
          </IconButton>
        </EnableFor>
      </DisabledWhenPolicyExceeded>
    </div>
  );
});
